import { render } from "./NewBadge.vue?vue&type=template&id=f447dca8&scoped=true"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"

import "./NewBadge.vue?vue&type=style&index=0&id=f447dca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f447dca8"]])

export default __exports__